import type { SavedViewItem } from "@/data-access/saved-views/queries/saved-views-queries";
import { derive } from "@/lib/derive-zustand";
import { useStore } from "zustand";
import useSavedViewStore from "./saved-views-management.slice";

/**
 * Derives all saved views as an array from the Map storage
 * Automatically updates when saved views are added, updated, or removed
 */
const deriveAllSavedViewsArray = derive<SavedViewItem[]>((get) => {
  const { allSavedViews } = get(useSavedViewStore);
  return Array.from(allSavedViews.values());
});

/**
 * Hook to get all saved views as an array
 */
export const useAllSavedViewsArray = () => useStore(deriveAllSavedViewsArray);
